"use strict";
/**
 * The narration search index packs many transactions' narrations into a handful
 * of chunk documents, so searching an account costs a few document reads instead
 * of one per transaction.
 *
 * Everything here is shared between the app and the server on purpose: if the two
 * disagree about chunk size or entry shape, writes land in chunks the reader never
 * looks in and transactions silently stop being searchable.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupNarrationEntries = exports.narrationEntryFor = exports.narrationIndexPath = exports.narrationChunkId = exports.NARRATION_INDEX_META_ID = exports.NARRATION_INDEX_CHUNK_SIZE = void 0;
/** Transactions packed into a single chunk document */
exports.NARRATION_INDEX_CHUNK_SIZE = 500;
/** Document id, alongside the numeric chunks, holding the build metadata */
exports.NARRATION_INDEX_META_ID = "meta";
/** Which chunk document a transaction's entry belongs in */
function narrationChunkId(transactionIndex) {
    return Math.floor(transactionIndex / exports.NARRATION_INDEX_CHUNK_SIZE);
}
exports.narrationChunkId = narrationChunkId;
/** Collection path holding an account's narration index */
function narrationIndexPath(bankId, bpay) {
    if (bpay === void 0) { bpay = false; }
    return "bankAccounts/".concat(bankId, "/").concat(bpay ? 'bpay-' : '', "narrationIndex");
}
exports.narrationIndexPath = narrationIndexPath;
/** Builds the stored entry for a transaction */
function narrationEntryFor(transaction) {
    var _a, _b, _c;
    return {
        n: String((_a = transaction.narration) !== null && _a !== void 0 ? _a : ""),
        x: transaction.index,
        d: (_b = transaction.date) !== null && _b !== void 0 ? _b : 0,
        t: (_c = transaction.transaction) !== null && _c !== void 0 ? _c : 0
    };
}
exports.narrationEntryFor = narrationEntryFor;
/**
 * Groups entries into the nested shape a chunk merge expects: chunk id chosen by
 * transaction index, entries keyed by document id.
 */
function groupNarrationEntries(entries) {
    var _a;
    var chunks = new Map();
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
        var _b = entries_1[_i], id = _b.id, entry = _b.entry;
        var chunkId = narrationChunkId(entry.x);
        var chunk = (_a = chunks.get(chunkId)) !== null && _a !== void 0 ? _a : {};
        chunk[id] = entry;
        chunks.set(chunkId, chunk);
    }
    return chunks;
}
exports.groupNarrationEntries = groupNarrationEntries;
